/// <amd-module name="CodeCoverage/Clients/Test/RestClient/Test" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-codecoverage-ci-web\clients\test\test.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Test from "CodeCoverage/Clients/Test/Contracts/Test";

export interface ITestRestClient extends IVssRestClient {
    /**
     * Get code coverage data for a build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param flags - Value of flags determine the level of code coverage details to be fetched. Flags are additive. Expected Values are 1 for Modules, 2 for Functions, 4 for BlockData.
     */
    getBuildCodeCoverage(project: string, buildId: number, flags: number): Promise<Test.BuildCoverage[]>;
    /**
     * Get Code Coverage Summary for Build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param deltaBuildId - Delta Build id (optional)
     */
    getCodeCoverageSummary(project: string, buildId: number, deltaBuildId?: number): Promise<Test.CodeCoverageSummary>;
}

class TestRestClient extends RestClientBase implements ITestRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get code coverage data for a build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param flags - Value of flags determine the level of code coverage details to be fetched. Flags are additive. Expected Values are 1 for Modules, 2 for Functions, 4 for BlockData.
     */
    public async getBuildCodeCoverage(
        project: string,
        buildId: number,
        flags: number
        ): Promise<Test.BuildCoverage[]> {

        const queryValues: any = {
            buildId: buildId,
            flags: flags
        };

        return this.beginRequest<Test.BuildCoverage[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/CodeCoverage",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Get Code Coverage Summary for Build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param deltaBuildId - Delta Build id (optional)
     */
    public async getCodeCoverageSummary(
        project: string,
        buildId: number,
        deltaBuildId?: number
        ): Promise<Test.CodeCoverageSummary> {

        const queryValues: any = {
            buildId: buildId,
            deltaBuildId: deltaBuildId
        };

        return this.beginRequest<Test.CodeCoverageSummary>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/CodeCoverage",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

}

export const TestClientName = "Coverage-Ci-WebPlatform.ITestRestClient";

export function getTestClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITestRestClient {
    return pageContext.getRestClient<ITestRestClient>(TestClientName, options);
}

RestClients.add(TestClientName, { 
    factory: TestRestClient,
    options: {
        resourceAreaId: "c2aa639c-3ccc-4740-b3b6-ce2a1e1d984e",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
